import $ from 'jquery'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import Swal from "sweetalert2";

import $store from "@/state/store";
import $router from "@/router";
import moment from "moment";
import { menuItems } from "@/components/menu.js";
import { BaseAbstractService } from "@/services/base.abstract.service";
import { getMerchanIDCurrent, getUserId, removeTypeSale } from '../utils/auth';
export class AuthService extends BaseAbstractService {
  static get baseUrl() {
    return `${process.env.VUE_APP_GATEWAY_API_URL}/host-master/api`;
  }
  static get url_proxy_gateway() {
    return `${process.env.VUE_APP_GATEWAY_API_URL}/proxy-gateway/gw-core`;
  }
  static get entityStore() {
    return "nsh/store/api/store"
  }

  static get menuStore() {
    const data = [
      {
        id: 1,
        label: "Tổng quan",
        link: "/store-merchant/overview",
        parentId: 7,
        permission: 'NSH_ONLINE_STORE_VIEW'
      },
      {
        id: 2,
        label: "Chi tiết gian hàng",
        link: "/store-merchant/product-list",
        parentId: 7,
        permission: 'NSH_ONLINE_STORE_VIEW'
      },
      {
        id: 3,
        label: "Thiết lập thông tin",
        link: "/setting/create-online-store",
        parentId: 7,
        permission: 'NSH_ONLINE_STORE_SETTING'
      },
    ]
    return data
  }

  /**
   ******************************
   * @API
   ******************************
   */

  static async popupFail(error) {
    Swal.fire({
      title: `${error} `,
      html: 'Vui lòng đăng nhập lại',
      confirmButtonColor: "#34c38f",
      confirmButtonText: "Xác nhận",
      imageUrl: require("@/assets/images/exclamation-triangle.svg"),
      imageWidth: 125,
      imageHeight: 125,
    }).then(resul => {
      window.open(`${process.env.VUE_APP_LOGIN}/logout?appId=5efef20c4521fd3aaabf4197&redirectUri=${encodeURIComponent(process.env.VUE_APP_REDIRECT_URL)}`,'_parent');
    })
  }

  static async getTokenNext360() {
    const request = {
      callbackUri: `${process.env.VUE_APP_URL}/token`,
      channel: "web",
      logout: true
    };
    const response = await this.callApi(false).post(`login`, request);
    if (response.data.success) {
      window.location = response.data.data.link;
    }
  }

  static async loginNext360(params) {
    try {
      const exp = _parseTokenData(params.token).exp;
      _setAccessToken({
        accessToken: params.token,
        exp: exp
      });
      const request = {
        channel: "WEB",
        userId: params.userId,
        merchantId: params.merchantId,
        appId: process.env.VUE_APP_ID
      };

      const resMerchant = await this.getInforMerchant(params.merchantId)
      const resUser = await this.getUser(request)
      const resStore = await this.getInforStore(resMerchant.aliasName)
      // check infor store return menu store online
      if (resStore.data.length > 0) {
        menuItems[4].subItems = this.menuStore
        $store.commit("auth/SET_MENU", menuItems);
        return resStore
      } else {
        $store.commit("auth/SET_MENU", menuItems);
        return resUser
      }
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static fetchToken(token){
    const exp = _parseTokenData(token).exp;
    _setAccessToken({
      accessToken: token,
      exp: exp
    });
  }

  static async getUser(params) {
    try {
      const response = await this.callApi().post(`user-info`, params);
      _setCurrentUser(response.data.data);
      if (!response.data.success) {
        this.popupFail(`User-${error}`)
      }
      else if (response.data.data.locationInfos.length === 0) {
        this.popupFail('Bạn chưa được gán với chi nhánh nào')
      } 
      else {
        return this.responseWrapper(response, response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  static async getInforStore(params) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_GATEWAY_API_URL}/${this.entityStore}/getByMerchantAliasName/${params}`
      )
      
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async getInforMerchant(params) {
    try {
      const response = await axios.get(
        `${this.url_proxy_gateway}/merchant/${params}`,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-app-id": process.env.VUE_APP_ID,
          }
        }
      );
      if (!response.data.success) {
        this.popupFail(`Merchant-${error}`)
      } else {
        $store.commit("auth/SET_CURRENT_MERCHANT", response.data.data);
        return response.data.data
      }
    } catch (error) {
      this.popupFail(`Merchant-${error}`)
    }
  }

  static async makeLogout() {
    try {
      const request = {
        logoutAll: true,
        merchantId: getMerchanIDCurrent(),
        userId: getUserId()
      };
      const response = await this.callApi().post("logout", request);
      await _resetAuthData();
      window.open(`${process.env.VUE_APP_LOGIN}/logout?appId=5efef20c4521fd3aaabf4197&redirectUri=${encodeURIComponent(process.env.VUE_APP_REDIRECT_URL)}`,'_parent');
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async packageBackHome() {
    try {
      const request = {
        logoutAll: true,
        merchantId: getMerchanIDCurrent(),
        userId: getUserId()
      };
      await this.callApi().post("logout", request);
      await _resetAuthData();
      window.open(`${process.env.VUE_APP_URL}/homepage`, '_parent');
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async refreshTokens() {
    try {
      _resetAuthData();
      return;
    } catch (error) {
      _resetAuthData();
      $router.push({ name: "login" }).catch(() => {});
      throw this.errorWrapper(error);
    }
  }

  static debounceRefreshTokens = this._debounce(() => {
    return this.refreshTokens();
  }, 100);

  /**
   ******************************
   * @METHODS
   ******************************
   */

  static isAccessTokenExpired() {
    const accessTokenExpDate = $store.state.auth.accessTokenExpDate - 10;
    const nowTime = Math.floor(new Date().getTime() / 1000);
    return accessTokenExpDate <= nowTime;
  }

  static hasRefreshToken() {
    return Boolean(localStorage.getItem("refreshToken"));
  }

  static setRefreshToken(status) {
    if (!["", "true"].includes(status)) {
      throw new Error(
        `setRefreshToken: invalid value ${status}; Expect one of ['', 'true']`
      );
    }

    localStorage.setItem("refreshToken", status);
  }

  static resetAuthData() {
    _resetAuthData();
  }

  static getBearer() {
    return _getCookie("TID");
  }

  static setBearer(accessToken) {
    //_saveCookie("TID", accessToken);
    const hoursCurent = moment().hours()
    const expiringTime = (24-hoursCurent) + 'h';
    _saveCookieTID("TID", accessToken, expiringTime);
  }

  static _debounce(inner, ms = 0) {
    let timer = null;
    let resolves = [];

    return function() {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const result = inner();
        resolves.forEach(r => r(result));
        resolves = [];
      }, ms);

      return new Promise(resolve => resolves.push(resolve));
    };
  }

  static async checkTokenExpires(){
    const token = _getCookie('TID')
    if(token === null || token == undefined || token === ''){
      console.log('Expires');
      await _resetAuthData();
    }
  }
}

/**
 ******************************
 * @private_methods
 ******************************
 */
function _parseTokenData(accessToken) {
  let payload = "";
  let tokenData = {};

  try {
    payload = accessToken.split(".")[1];
    tokenData = JSON.parse(atob(payload));
  } catch (error) {
    throw new Error("Token sai, Login thất bại");
  }

  return tokenData;
}

function _resetAuthData() {
  _setCurrentUser(null);
  localStorage.clear();
  removeTypeSale()
  VueCookies.keys().forEach(cookie => VueCookies.remove(cookie))
  $store.replaceState({
    auth: {},
    item:{},
    layout:{},
    notification:{},
    odersCustomer:{},
    orders:{},
    products:{},
    report:{},
    storeCustomer:{},
  });
}

function _setCurrentUser(user) {
  $store.commit("auth/SET_CURRENT_USER", user);
  if(user){
    // const locationId = (user.locationInfos[0]) ? user.locationInfos[0].id : ''
    // localStorage.setItem('LID', locationId);
    _saveCookie('UID',user.userId)
    _saveCookie('MID',user.merchantId)
  }
  return true
}

function _setAccessToken({ accessToken, exp } = {}) {
  AuthService.setRefreshToken("true");
  AuthService.setBearer(accessToken);
  $store.commit("auth/SET_ATOKEN_EXP_DATE", exp);
}

function _getCookie(key) {
  return VueCookies.isKey(key)?VueCookies.get(key):null;
}

function _saveCookie(key, state) {
  VueCookies.set(key,state)
}
function _saveCookieTID(key, state, expires) {
  VueCookies.set(key, state, expires)
}

(function($){
    $.oauthPopup = function(options){
        options.windowName = options.windowName || 'ConnectWithOAuth';
        let left = (screen.width/2)-(options.width/2);
        let top = (screen.height/2)-(options.height/2) - 20;
        options.windowOptions = options.windowOptions || 'location=0,status=0,width='+options.width+',height='+options.height+',scrollbars=1,top='+top+',left='+left;
        options.callback = options.callback || function(){ window.location.reload(); };
        let that = this;
        that._oauthWindow = window.open(options.path, options.windowName, options.windowOptions);
        that._oauthInterval = window.setInterval(function(){
            if (that._oauthWindow.closed) {
                window.clearInterval(that._oauthInterval);
                options.callback();
            }
        }, 2000);
    };
})($);
